module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("b3UZE"))).then(() => parcelRequire('3a9aZ'));